import { MDCTextField } from '@material/textfield/dist/mdc.textfield';

/**
 * Init MDC Text Fields.
 * 
 * @link https://github.com/material-components/material-components-web/tree/v0.28.0/master/packages/mdc-textfield
 *
 * @since 0.0.1
 * @return {void} 
 */
export function initMDCTextField(field) {
	if (field) {
		new MDCTextField(field);
	}
}

export function initMDCTextFields() {
	const fields = document.querySelectorAll('.mdc-text-field');
	fields.forEach((field, i) => {
		initMDCTextField(field);
	});
}